import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userSlice from "./userSlice";
import apiSlice from "./apiSlice";
import modalSlice from "./modalSlice";
import screenSlice from "./screenSlice";
import memberApiSlice from "./memberApiSlice";
import adminUserApiSlice from "./adminUserApiSlice";
import findMemberSearchResultReducer from "./findMemberSearchResultSlice";
import searchMemberApiSlice from "./searchMemberApiSlice";
import currentMemberSliceReduce from "./currentMemberSlice";
import editMemberapiSlice from "./editMemberapiSlice";
import findMemberListUpdatedApiSlice from "./findMemberUpdatedApiSlice";
import eventApiSlice from "./eventApiSlice";
import orderApiSlice from "./orderApiSlice";
import guestOrderApiSlice from "./guestOrderApiSlice";
import hasSearchParamFlags from "./hasSearchParamFlags";

const rootReducer = combineReducers({
  screen: screenSlice,
  user: userSlice,
  api: apiSlice,
  modal: modalSlice,
  eventapislice: eventApiSlice,
  orderapislice: orderApiSlice,
  guestOrderapislice: guestOrderApiSlice,
  memberApiSlice: memberApiSlice,
  adminUserApiSlice: adminUserApiSlice,
  findMemberList: findMemberSearchResultReducer,
  searchMemberApiSlice: searchMemberApiSlice,
  currentMember: currentMemberSliceReduce,
  editMemberapiSlice: editMemberapiSlice,
  findMemberListUpdatedApiSlice: findMemberListUpdatedApiSlice,
  hasSearchParamFlags: hasSearchParamFlags,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/PAUSE', 'persist/PURGE', 'persist/REGISTER'],
      },
    }),
});

export const persistor = persistStore(store);

// Define RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
